{
  "it": {
    "ticket_category": {
      "Decisions": "Decisione",
      "Issue": "Post-vendita",
      "Regular": "Generale",
      "labels": {
        "ticket_category": "Tipo"
      }
    }
  }
}
